export default {
  title: '¡Encuentra algo que te encante!',
  description: 'Tus pedidos aparecerán aquí.',
  buttons: {
    order_now: 'Pedir ahora',
  },
};
